import Dummy from "components/Dummy";
import P from "components/P";
import Inline from "layouts/container/Inline";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import VerticalFlex from "layouts/flex/VerticalFlex";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import gridIcon from "resources/img/category/grid.png";
import listIcon from "resources/img/category/list.png";
import { HistoryReducer } from "shared/redux/reducers/history/HistoryReducer";

function FilterTopBar({ filterArray, medusaProducts, list, categoryId, setCurrentType, filter, filterClick }) {
    const { t } = useTranslation();
    const GALLERY = 0;
    const LIST = 1;
    const dispatch = useDispatch();

    const [isVisible, setIsVisible] = useState(true);
    const lastScrollY = useRef(window.scrollY);
    const headerHeight = 81; // 스크롤 감지 높이

    useEffect(() => {
        let ticking = false;

        const updatePosition = () => {
            const currentScrollY = window.scrollY;
            const isScrollingDown = currentScrollY > lastScrollY.current;

            if (currentScrollY < headerHeight) {
                setIsVisible(true);
            } else {
                if (isScrollingDown && currentScrollY > headerHeight) {
                    setIsVisible(false);
                } else {
                    setIsVisible(true);
                }
            }

            lastScrollY.current = currentScrollY;
            ticking = false;
        };

        const onScroll = () => {
            if (!ticking) {
                window.requestAnimationFrame(() => {
                    updatePosition();
                });
                ticking = true;
            }
        };

        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, []);


    const onGalleryClick = () => {

        dispatch(HistoryReducer.actions.setCurrentType(GALLERY));
        setCurrentType(GALLERY);
    }

    const onListClick = () => {

        dispatch(HistoryReducer.actions.setCurrentType(LIST));
        setCurrentType(LIST);
    }
    return (
        <div style={{
            position: "fixed",
            top: isVisible ? "160px" : "20px",
            zIndex: 999,
            minWidth: "768px",
            maxWidth: "1300px",
            backgroundColor: "white",
            transition: "top 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
        }}>            <VerticalFlex>
                <FlexChild>
                    <Dummy height={"20px"} />
                </FlexChild>
                <FlexChild alignItems={"flex-start"}>
                    <Inline padding={"10px"}>
                        <P size={24} weight={700}>{t("전체")} </P>
                        <P color={"var(--main-color)"} size={24} weight={700}>{medusaProducts && categoryId === "all" ? medusaProducts.length : list ? list.length : 0}{t("개")}</P>
                        <P size={24} weight={700}> {t("브랜드")}</P>
                    </Inline>
                </FlexChild>
                <FlexChild>
                    <div style={{ width: "100%", height: "4px", backgroundColor: "rgba(206, 206, 206, 1)" }} />
                </FlexChild>
                <FlexChild>
                    <HorizontalFlex>
                        <FlexChild padding={"10px 15px"}>
                            <HorizontalFlex gap={25}>
                                {
                                    filterArray.map((data, index) => {
                                        return (
                                            <FlexChild width={filterArray.length === index + 1 ? null : "max-content"}>
                                                <Inline>
                                                    <P size={18} cursor weight={filter === index ? 700 : 500} onClick={() => filterClick(index)}>{data}</P>
                                                    {
                                                        filterArray.length === index + 1
                                                            ? null
                                                            :
                                                            <P padding={"0 0 0 25px"}>|</P>
                                                    }
                                                </Inline>
                                            </FlexChild>
                                        );
                                    })
                                }
                            </HorizontalFlex>
                        </FlexChild>
                        <FlexChild justifyContent={"flex-end"} padding={"0 20px 0 0"} width={"max-content"}>
                            <div style={{ display: "flex", justifyContent: "flex-end", gap: "25px", alignItems: "center" }}>
                                <div style={{ width: "1.5px", height: "50px", backgroundColor: "rgba(206, 206, 206, 1)" }} />
                                <img
                                    src={gridIcon}
                                    width={"20px"}
                                    height={"20px"}
                                    style={{ cursor: "pointer" }}
                                    onClick={onGalleryClick}
                                />
                                <img
                                    src={listIcon}
                                    width={"20px"}
                                    height={"20px"}
                                    style={{ cursor: "pointer" }}
                                    onClick={onListClick}
                                />
                            </div>
                        </FlexChild>
                    </HorizontalFlex>
                </FlexChild>
                <FlexChild>
                    <div style={{ width: "100%", height: "1.5px", backgroundColor: "rgba(206, 206, 206, 1)" }} />
                </FlexChild>
            </VerticalFlex>
        </div>
    )
}

export default FilterTopBar;